const CHANNEL = 'lumi-auth';
const TAB_ID = (typeof crypto !== 'undefined' && 'randomUUID' in crypto)
  ? (crypto as any).randomUUID()
  : Math.random().toString(36).slice(2);

type AuthChanged = { type: 'auth:changed'; at: number; tabId: string };

let bc: BroadcastChannel | null =
  typeof window !== 'undefined' && 'BroadcastChannel' in window
    ? new BroadcastChannel(CHANNEL)
    : null;

export function postAuthChanged() {
  try {
    bc?.postMessage({ type: 'auth:changed', at: Date.now(), tabId: TAB_ID } as AuthChanged);
  } catch {}
}

export function onAuthChanged(cb: () => void): () => void {
  const handler = (e: MessageEvent<AuthChanged>) => {
    try {
      if (e?.data?.type === 'auth:changed' && e.data.tabId !== TAB_ID) cb();
    } catch {}
  };
  bc?.addEventListener('message', handler as any);

  // Fallback: react to Supabase updating our namespaced localStorage key
  if (typeof window !== 'undefined') {
    const storageHandler = (ev: StorageEvent) => {
      try {
        if (ev.key && ev.key.startsWith('lumi.auth.v1.')) cb();
      } catch {}
    };
    window.addEventListener('storage', storageHandler);
    return () => {
      try { bc?.removeEventListener('message', handler as any); } catch {}
      try { window.removeEventListener('storage', storageHandler); } catch {}
    };
  }

  return () => {
    try { bc?.removeEventListener('message', handler as any); } catch {}
  };
}


